import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const approaches = ['Las recetas de "meal prep" dominical te roban tu único tiempo de descanso y la comida pierde frescura el miércoles.', 'Intentar cocinar desde cero cada mañana es una receta garantizada para el agotamiento y llegar tarde a la oficina.', 'Los productos "saludables" ultraprocesados son costosos y dejan a tu hijo sin energía real antes del mediodía.'];
export function FailedApproaches() {
  return <section className="bg-white py-20 px-6" data-id="element-3">
      <div className="max-w-5xl mx-auto" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-5">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-4" data-id="element-6">
            Por qué lo que has intentado no funciona
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7">
          {approaches.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-[#FFF8F0] p-8 rounded-2xl relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-8">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#E76F51] text-white p-3 rounded-full shadow-lg group-hover:scale-110 transition-transform" data-id="element-9">
                <XIcon size={24} strokeWidth={3} data-id="element-10" />
              </div>
              <p className="text-[#5C4B3A] text-center mt-4 leading-relaxed" data-id="element-11">
                {text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}